export default "__VITE_ASSET__D$KmSokW__"